<template>
  <div class="basicDataSummarys">
    <div class="leftBox">
      <el-card class="leftCard">
        <div class="cardTitle">基本信息&设备统计</div>
        <div class="leftInfoBox">
          <div class="leftFlex">
            <span class="lebelText">物业人数：</span>
            <p class="infoText">{{basicData.staffCount}}</p>
            <!-- <span class="lebelText">人</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">业主人数：</span>
            <p class="infoText">{{basicData.roomOwnerCount}}</p>
            <!-- <span class="lebelText">人</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">楼栋数：</span>
            <p class="infoText">{{basicData.gardenGridCount}}</p>
            <!-- <span class="lebelText">栋</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">车位数量：</span>
            <p class="infoText">{{basicData.carPlaceCount}}</p>
            <!-- <span class="lebelText">个</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">出入口数量：</span>
            <p class="infoText">{{basicData.gateCount}}</p>
            <!-- <span class="lebelText">个</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">工单总数：</span>
            <p class="infoText">{{basicData.maintainCount}}</p>
            <!-- <span class="lebelText">条</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">今年工单数：</span>
            <p class="infoText">{{basicData.maintainCountYear}}</p>
          </div>
          <div class="leftFlex">
            <span class="lebelText">业主报事总数：</span>
            <p class="infoText">{{basicData.maintainCountByUser}}</p>
            <!-- <span class="lebelText">条</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">今年业主报事数：</span>
            <p class="infoText">{{basicData.maintainCountByUserYear}}</p>
          </div>
          <div class="leftFlex">
            <span class="lebelText">巡检工单总数：</span>
            <p class="infoText">{{basicData.maintainCountByJob}}</p>
            <!-- <span class="lebelText">条</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">今年巡检工单数：</span>
            <p class="infoText">{{basicData.maintainCountByJobYear}}</p>
          </div>
          <div class="leftFlex">
            <span class="lebelText">设备总数：</span>
            <p class="infoText">{{basicData.deviceCount}}</p>
            <!-- <span class="lebelText">个</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">电梯总数：</span>
            <p class="infoText">{{basicData.liftCount}}</p>
            <!-- <span class="lebelText">部</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">蓝牙门禁数量：</span>
            <p class="infoText">{{basicData.doorDeviceCount}}</p>
            <!-- <span class="lebelText">个</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">蓝牙梯控数量：</span>
            <p class="infoText">{{basicData.liftDeviceCount}}</p>
            <!-- <span class="lebelText">个</span> -->
          </div>
          <div class="leftFlex">
            <span class="lebelText">园区鹰眼数量：</span>
            <p class="infoText">{{basicData.videoMonitorInterfaceCount}}</p>
            <!-- <span class="lebelText">个</span> -->
          </div>
        </div>
      </el-card>
      <el-card class="leftCard">
        <div class="cardTitle">接单排行榜</div>
        <div class="container">
          <div id="echart1"></div>
        </div>

      </el-card>
      <el-card class="leftCard">
        <div class="cardTitle">报单排行榜</div>
        <div class="container">
          <div id="echart2"></div>
        </div>
      </el-card>
    </div>
    <div class="centerBox">
      <el-card class="centerCard">
        <div class="cardTitle">物业费收取统计</div>
        <div class="container">
          <div id="echart3"></div>
        </div>
      </el-card>
      <el-card class="centerCard">
        <div class="cardTitle">车位费收取统计</div>
        <div class="container">
          <div id="echart4"></div>
        </div>
      </el-card>
      <el-card class="centerCard card400">
        <div class="cardTitle">工单类型统计</div>
        <div class="container400">
          <div id="echart5"></div>
        </div>
      </el-card>
      <el-card class="centerCard card345">
        <div class="cardTitle">月度工单统计</div>
        <div class="container290">
          <div id="echart6"></div>
        </div>
      </el-card>
    </div>
    <div class="rightBox">
      <el-card class="rightCard">
        <div class="cardTitle">园区门禁通行流量统计</div>
        <div class="container">
          <div id="echart7"></div>
        </div>
      </el-card>
      <el-card class="rightCard">
        <div class="cardTitle">接单及时率统计</div>
        <div class="container">
          <div id="echart8"></div>
        </div>
      </el-card>
      <el-card class="rightCard">
        <div class="cardTitle">完结率统计</div>
        <div class="container">
          <div id="echart9"></div>
        </div>
      </el-card>
      <el-card class="rightCard">
        <div class="cardTitle">满意率统计</div>
        <div class="container">
          <div id="echart10"></div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:basicDataSummarys
   *@Description:基础数据汇总统计
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2022-11-9
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.basicDataSummarys',
    data() {
      return {
        gardenId: this.$store.getters.gardenId, // 园区id
        basicData: {}, // 基础信息
      }
    },
    created() {
      this.getBasicData()
      this.getDeviceData()
      this.getMaintainCountByRank()
      this.getPayInfowy()
      this.getPayInfocar()
      this.getMaintainType()
      this.getMaintainMonthCount()
      this.getDoorDeviceRecord()
      this.getMaintainOverTime()
      this.getMaintainState()
      this.getMaintainEvaluate()
    },
    methods: {
      // 获取基本信息数据
      getBasicData() {
        let loading = this.$loading()
        this.$get(
          `/selectBasicData?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.$set(this.basicData, 'carPlaceCount', res.carPlaceCount)
              this.$set(this.basicData, 'gardenGridCount', res.gardenGridCount)
              this.$set(this.basicData, 'gateCount', res.gateCount)
              this.$set(this.basicData, 'maintainCount', res.maintainCount)
              this.$set(this.basicData, 'maintainCountByJob', res.maintainCountByJob)
              this.$set(this.basicData, 'maintainCountByUser', res.maintainCountByUser)
              this.$set(this.basicData, 'maintainCountYear', res.maintainCountYear)
              this.$set(this.basicData, 'maintainCountByJobYear', res.maintainCountByJobYear)
              this.$set(this.basicData, 'maintainCountByUserYear', res.maintainCountByUserYear)
              this.$set(this.basicData, 'roomOwnerCount', res.roomOwnerCount)
              this.$set(this.basicData, 'staffCount', res.staffCount)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取设备信息数据
      getDeviceData() {
        let loading = this.$loading()
        this.$get(
          `/selectDeviceData?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.$set(this.basicData, 'deviceCount', res.deviceCount)
              this.$set(this.basicData, 'doorDeviceCount', res.doorDeviceCount)
              this.$set(this.basicData, 'liftCount', res.liftCount)
              this.$set(this.basicData, 'liftDeviceCount', res.liftDeviceCount)
              this.$set(this.basicData, 'videoMonitorInterfaceCount', res.videoMonitorInterfaceCount)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单报单排行榜数据
      getMaintainCountByRank() {
        let loading = this.$loading()
        this.$get(
          `/selectMaintainCountByRank?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              // res.putMaintainCountByRank // 接单排行榜
              // res.getMaintainCountByRank // 报单排行榜
              this.getLoadEcharts1(res.putMaintainCountByRank)
              this.getLoadEcharts2(res.getMaintainCountByRank)
              console.log(res)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取物业缴费数据
      getPayInfowy() {
        let loading = this.$loading()
        this.$get(
          `/selectPayInfo?gardenId=${this.gardenId}&type=1`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.payInfo) {
                let data = []
                let isPay = {}
                let noPay = {}
                isPay.name = '实收'
                isPay.value = res.payInfo.paidAmountCount
                noPay.name = '未收'
                noPay.value = res.payInfo.receiveAmountCount - res.payInfo.paidAmountCount
                if (isPay.value > 0) {
                  data.push(isPay)
                }
                if (noPay.value > 0) {
                  data.push(noPay)
                }
                console.log(data)
                this.getLoadEcharts3(data)
              } else {
                this.getLoadEcharts3(null)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取车位缴费数据
      getPayInfocar() {
        let loading = this.$loading()
        this.$get(
          `/selectPayInfo?gardenId=${this.gardenId}&type=2`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.payInfo) {
                let data = []
                let isPay = {}
                let noPay = {}
                isPay.name = '实收'
                isPay.value = res.payInfo.paidAmountCount
                noPay.name = '未收'
                noPay.value = res.payInfo.receiveAmountCount - res.payInfo.paidAmountCount
                data.push(isPay)
                data.push(noPay)
                this.getLoadEcharts4(data)
              } else {
                this.getLoadEcharts4(null)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取工单类型统计数据
      getMaintainType() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainTypeCount?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.getLoadEcharts5(res.data)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取月度工单统计数据
      getMaintainMonthCount() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainMonthCount?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res.data)
              let x = res.data.map(item => (
                item.name + '日'
              ))
              let y = res.data.map(item => (
                item.value
              ))
              this.getLoadEcharts6(x, y)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取园区门禁通行流量数据
      getDoorDeviceRecord() {
        let loading = this.$loading()
        this.$get(
          `/selectDoorDeviceRecord?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.getLoadEcharts7(res.data)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单及时率数据
      getMaintainOverTime() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainOverTime?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.getLoadEcharts8(res.data)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单完结率数据
      getMaintainState() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainState?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.getLoadEcharts9(res.data)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单满意率数据
      getMaintainEvaluate() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainEvaluate?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.getLoadEcharts10(res.data)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },

      // 获取接单排行图表
      getLoadEcharts1(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart1')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          let nameList = data.putMaintainCountByRank.map(item => {
            var arr = item.name.split('-')
            return arr[arr.length - 1]
          }).reverse()

          let maintainCountList = data.putMaintainCountByRank.map(item => {
            return item.MaintainCount
          }).reverse()
          var myChart1 = this.$echarts.init(
            document.getElementById('echart1')
          )
          var option1 = {
            title: {

            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: ''
              }
            },
            legend: {},
            grid: {
              top: '0%',
              left: '3%',
              right: '4%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01],
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            yAxis: {
              type: 'category',
              data: nameList,
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            series: [{
              type: 'bar',
              data: maintainCountList,
              itemStyle: {
                normal: {
                  color: {
                    type: 'linear',

                    colorStops: [{
                        offset: 0,
                        color: '#748ede',
                      },
                      {
                        offset: 1,
                        color: '#5470c6',
                      }
                    ]
                  }
                  // color: function (params) {
                  //   // var colorList = ['#91cc75', '#ee6666', '#fac858', '#73c0de', '#91cc75']
                  //   // return colorList[params.dataIndex]
                  //   // return '#' + Math.floor(Math.random() * (256 * 256 * 256 - 1)).toString(16)
                  //   return '#5470c6'
                  // }
                },
                emphasis: {
                  color: '#748ede'
                }, // 鼠标悬停颜色
              },
            }, ]
          }
          myChart1.setOption(option1)
        }
      },
      // 获取报单排行图表
      getLoadEcharts2(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart2')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          let nameList = data.getMaintainCountByRank.map(item => {
            var arr = item.name.split('-')
            return arr[arr.length - 1]
          }).reverse()

          let maintainCountList = data.getMaintainCountByRank.map(item => {
            return item.MaintainCount
          }).reverse()
          var myChart2 = this.$echarts.init(
            document.getElementById('echart2')
          )
          var option2 = {
            title: {

            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: ''
              }
            },
            legend: {},
            grid: {
              top: '0%',
              left: '3%',
              right: '4%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01],
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            yAxis: {
              type: 'category',
              data: nameList,
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            series: [{
              type: 'bar',
              data: maintainCountList,
              itemStyle: {
                normal: {
                  color: {
                    type: 'linear',

                    colorStops: [{
                        offset: 0,
                        color: '#748ede',
                      },
                      {
                        offset: 1,
                        color: '#5470c6',
                      }
                    ]
                  }
                  // color: function (params) {
                  //   // var colorList = ['#91cc75', '#ee6666', '#fac858', '#73c0de', '#91cc75']
                  //   // return colorList[params.dataIndex]
                  //   // return '#' + Math.floor(Math.random() * (256 * 256 * 256 - 1)).toString(16)
                  //   return '#5470c6'
                  // }
                },
                emphasis: {
                  color: '#748ede'
                }, // 鼠标悬停颜色
              },
            }, ]
          }
          myChart2.setOption(option2)
        }
      },
      // 获取物业费图表
      getLoadEcharts3(data) {
        if (!data) {
          var dom = document.getElementById('echart3')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart3 = this.$echarts.init(
            document.getElementById('echart3')
          )
          var option3 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#F97F51', '#6a89cc'],
            legend: {
              bottom: '0',
              right: '0'
            },
            series: [{
              name: '物业费收取统计',
              type: 'pie',
              radius: ['30%', '80%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 13
                  }
                }
              },
              data: data
            }]
          }
          myChart3.setOption(option3)
        }
      },
      // 获取车位费图表
      getLoadEcharts4(data) {
        if (!data) {
          var dom = document.getElementById('echart4')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart4 = this.$echarts.init(
            document.getElementById('echart4')
          )
          var option4 = {
            tooltip: {
              trigger: 'item'
            },
            // color: ['#F38235', '#95B1CE'],
            color: ['#F97F51', '#6a89cc'],
            legend: {
              bottom: '0',
              right: '0'
            },
            series: [{
              name: '车位费收取统计',
              type: 'pie',
              radius: ['30%', '80%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 13
                  }
                }
              },
              data: data
            }]
          }
          myChart4.setOption(option4)
        }
      },
      // 获取工单类型图表
      getLoadEcharts5(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart5')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 80
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart5 = this.$echarts.init(
            document.getElementById('echart5')
          )
          var option5 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '0',
              lfet: '0'
            },
            color: ['#F97F51', '#6a89cc', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4', '#F97F51', '#6a89cc', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4'],
            series: [{
              name: '工单类型',
              type: 'pie',
              radius: '50% 30%',
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 13
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart5.setOption(option5)
        }
      },
      // 获取月度工单统计图表
      getLoadEcharts6(x, y) {
        var noData = y.every(item => item <= 0)
        if (noData) {
          var dom = document.getElementById('echart6')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 80
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart6 = this.$echarts.init(
            document.getElementById('echart6')
          )
          var option6 = {
            tooltip: {
              trigger: 'axis'
            },
            grid: {
              top: '3%',
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: x
            },
            yAxis: {
              type: 'value'
            },
            series: [{
              name: '工单数',
              type: 'line',
              itemStyle: {
                normal: {
                  color: '#ee6666',
                  lineStyle: {
                    color: '#ee6666'
                  }
                }
              },
              data: y,
            }]
          }
          myChart6.setOption(option6)
        }
      },
      // 园区门禁通行流量图表
      getLoadEcharts7(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart7')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart7 = this.$echarts.init(
            document.getElementById('echart7')
          )
          var option7 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              right: '0'
            },
            color: ['#F97F51', '#6a89cc', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4', '#F97F51', '#6a89cc', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4'],
            series: [{
              name: '园区门禁通行流量统计',
              type: 'pie',
              radius: '70%',
              center: ['50%', '50%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart7.setOption(option7)
        }
      },
      // 获取接单及时率图表
      getLoadEcharts8(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart8')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart8 = this.$echarts.init(
            document.getElementById('echart8')
          )
          var option8 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              right: '0'
            },
            // color: ['#71C281', '#FFB16D'],
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: '接单率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart8.setOption(option8)
        }
      },
      // 获取完结率图表
      getLoadEcharts9(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart9')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart9 = this.$echarts.init(
            document.getElementById('echart9')
          )
          var option9 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              right: '0'
            },
            // color: ['#71C281', '#FFB16D'],
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: '完结率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart9.setOption(option9)
        }
      },
      // 获取满意率图表
      getLoadEcharts10(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart10')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart10 = this.$echarts.init(
            document.getElementById('echart10')
          )
          var option10 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              right: '0'
            },
            // color: ['#5470c6', '#91cc75', '#ee6666', '#fac858', '#73c0de', '#3ba272', '#fc8452', '#9a60b4',
            //   '#ea7ccc'],
            color: ['#F97F51', '#6a89cc', '#91CC75', '#FAC858'],
            series: [{
              name: '满意率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              // radius: '70%',
              center: ['50%', '50%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart10.setOption(option10)
        }
      },

    }
  }
</script>

<style lang="scss">
  .basicDataSummarys {
    display: flex;
    // flex-wrap: wrap;

    .leftBox,
    .centerBox,
    .rightBox {
      flex: 1;
      margin-right: 20px;
    }

    .cardTitle {
      font-size: 18px;
      padding-left: 10px;
      margin-left: 10px;
      margin-bottom: 30px;
      border-left: 3px solid #ff6207;
    }

    .leftBox {
      .leftCard {
        margin-bottom: 20px;

        .leftInfoBox {
          display: flex;
          flex-wrap: wrap;

          .leftFlex {
            flex: 1 47%;
            display: flex;
            background-color: #f5f5f5;
            border-radius: 5px;
            margin: 0 10px 10px 0;
            padding: 10px;
            box-sizing: border-box;
            align-items: center;

            .lebelText {
              font-size: 16px;
            }

            .infoText {
              flex: 1;
              text-align: right;
              font-size: 28px;
              color: #00b1c3;
              margin-right: 15px;
            }
          }
        }

        .leftInfoBox::after {
          flex: 1 50%;
          content: '';
        }

        .container {
          width: 100%;
          height: 348px;
          margin-left: 30px;
        }
      }

    }

    .centerBox {
      .centerCard {
        margin-bottom: 20px;

        .container {
          width: 100%;
          height: 230px;
          margin-left: 30px;
        }

        .container290 {
          width: 100%;
          height: 290px;
          margin-left: 30px;
        }

        .container400 {
          width: 100%;
          height: 400px;
          margin-left: 30px;
        }
      }

    }

    .rightBox {
      margin-right: 0;

      .rightCard {
        margin-bottom: 20px;

        .container {
          width: 100%;
          height: 274px;
          margin-left: 30px;
        }
      }
    }

    .card345 {
      height: 344px !important;
    }

    .card400 {
      height: 400px !important;
    }

    #echart1,
    #echart2,
    #echart3,
    #echart4,
    #echart5,
    #echart6,
    #echart7,
    #echart8,
    #echart9,
    #echart10,
      {
      width: 90%;
      height: 100%;
    }
  }
</style>